"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAddressAptosOperation = void 0;
var common_aptos_utils_1 = require("@moralisweb3/common-aptos-utils");
exports.deleteAddressAptosOperation = {
    method: 'DELETE',
    name: 'deleteAddressAptos',
    id: 'aptosStreamsDeleteAddresses',
    groupName: 'aptosStreams',
    urlPathParamNames: ['id'],
    urlPathPattern: "/streams/aptos/{id}/address",
    bodyParamNames: ['address'],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        id: request.id,
    };
}
function getRequestBody(request) {
    return {
        address: Array.isArray(request.address)
            ? request.address.map(function (address) { return common_aptos_utils_1.AptosAddress.create(address).address; })
            : common_aptos_utils_1.AptosAddress.create(request.address).address,
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request) {
    return {
        id: request.id,
        address: Array.isArray(request.address)
            ? request.address.map(function (address) { return common_aptos_utils_1.AptosAddress.create(address).address; })
            : common_aptos_utils_1.AptosAddress.create(request.address).address,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        id: jsonRequest.id,
        address: Array.isArray(jsonRequest.address)
            ? jsonRequest.address.map(function (address) { return common_aptos_utils_1.AptosAddress.create(address); })
            : common_aptos_utils_1.AptosAddress.create(jsonRequest.address),
    };
}
//# sourceMappingURL=deleteAddressAptosOperation.js.map